import { truncateHTML } from './utils.js';

export const initNewsCarousel = () => {
    let nextId = 0;
    let nextIdMobile = 0;

    Alpine.data('newsCarousel', () => ({
        id: nextId++,
        isOpen: false,
        fullHTML: '',
        shortenedText: '',
        maxHeight: '0px',


        init() {
            this.fullHTML = this.$refs.fullText.innerHTML;
            this.shortenedText = this.$refs.teaserText.innerHTML || truncateHTML(this.fullHTML, 250);
            window.addEventListener('closeNews', (e) => {
                this.isOpen = (!(this.id === e.detail.not)) ? false : this.isOpen;
            });
        },
        toggle() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$dispatch('closeNews', {not: this.id}, true);
            }
        },
    }));

    Alpine.data('newsCarouselMobile', () => ({
        id: nextIdMobile++,
        isOpen: false,
        fullHTML: '',
        shortenedText: '',

        init() {
            this.fullHTML = this.$refs.fullText.innerHTML;
            this.shortenedText = truncateHTML(this.fullHTML, 250);
            window.addEventListener('closeNewsMobile', (e) => {
                this.isOpen = (!(this.id === e.detail.not)) ? false : this.isOpen;
            });
        },
        toggle() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$dispatch('closeNewsMobile', {not: this.id}, true);
            }
        },
    }));


}